import { FirebaseError } from 'firebase/app';
import type { ApiError } from '@chikara/types';
import { t } from '@/i18n';

export function mapFirebaseError(error: unknown): ApiError {
  if (error instanceof TypeError && error.message === 'Failed to fetch') {
    return {
      type: 'network',
      status: 500,
      message: t('errors.network')
    };
  }

  // 🔐 Errores Firebase
  if (error instanceof FirebaseError) {
    let message = t('firebaseError.default');

    switch (error.code) {
      case 'auth/invalid-credential':
        message = t('firebaseError.invalidCredential');
        break;
      case 'auth/user-disabled':
        message = t('firebaseError.userDisabled');
        break;
    }

    return {
      type: 'http',
      status: 401,
      code: error.code,
      message,
    };
  }

  // ❓ Fallback
  return {
    type: 'network',
    status: 500,
    message: t('errors.unknown'),
  };
}
